import React from 'react'
import axios from 'axios'
import { FormattedMessage } from 'react-intl'
import Config from '../../commons/config/Config.js'
import * as Constants from '../atributoDinamico/constants.js'
import { esItemRelevante } from '../atributoDinamico/helpers.js'
import EstadoDecisionAuditor from './EstadoDecisionAuditor.jsx'

const configAxios = {
	headers: {
		'Authorization-Token': localStorage.getItem("token")
	}
};

// VEC-3637: grilla de solo lectura de la validación granular de un checklist, para la vista
// detalle (FormularioAbm) cuando checklist.validacion.granular.habilitado = true. Estructura
// similar a ValidacionGranularModal (misma grilla de columnas), sin checkboxes ni botones de
// decisión — no comparte el render de fila con el modal a propósito (ver plan VEC-3637): el
// modal está fuertemente acoplado a estado interactivo (borrador, selección múltiple) que no
// aplica acá. Sí comparte EstadoDecisionAuditor y esItemRelevante, que son las piezas donde un
// drift entre ambas vistas importaría (bug visual del truncado, y bug de datos del filtro).
function openImage(adjunto_id) {
	let config = Object.assign({}, configAxios, { responseType: 'blob' });
	axios.get(Config.get('apiUrlBase') + '/adjuntos/files/' + adjunto_id, config).then(response => {
		if (response.status === 200) {
			let fileUrl = URL.createObjectURL(response.data);
			window.open(fileUrl)
		}
	}).catch((e) => { console.log(e) });
}

function renderFila(valorDinamico, index, intl) {
	let vigente = valorDinamico.ultima_validacion;
	let vigenteActiva = !!(vigente && vigente.decision !== Constants.ID_DECISION_CANCELADO);

	return (
		<div className="row align-items-start border-bottom py-2 mx-0" key={index}>
			<div className="col-1"></div>
			<div className="col-3 text-truncate" title={valorDinamico.nombre}>
				{valorDinamico.nombre}
			</div>
			<div className="col-3">
				{Constants.INSTANCIAS_DICT[valorDinamico.tipoValor].conAdjunto ?
					<span>
						{valorDinamico.value && typeof (valorDinamico.value) === 'number' &&
							<i onClick={() => openImage(valorDinamico.value)} className="cursor-pointer pr-1 fa fa-2x fa-paperclip"></i>
						}
						{valorDinamico.value && typeof (valorDinamico.value) !== 'number' && valorDinamico.value.map((e, i) =>
							<i key={i} onClick={() => openImage(e)} className="cursor-pointer pr-1 fa fa-2x fa-paperclip"></i>
						)}
						{!valorDinamico.value &&
							<FormattedMessage id="formularioDetail.information_no_posee_adjunto" defaultMessage="No posee adjunto" />
						}
					</span>
					:
					<div
						className={'text-truncate ' + (
							valorDinamico.estado === Constants.ID_ESTADO_APROBACION_INVALIDO ? 'danger' :
								valorDinamico.estado === Constants.ID_ESTADO_APROBACION_VALIDO ? 'success' : ''
						)}
						title={valorDinamico.value != null ? String(valorDinamico.value) : ''}
					>
						{valorDinamico.value}
					</div>
				}
				{valorDinamico.adjuntos && valorDinamico.adjuntos.map((a, i) =>
					<i key={i} onClick={() => openImage(a.adjunto_id)} className="cursor-pointer pr-1 fa fa-1_4x fa-paperclip"></i>
				)}
			</div>
			<div className="col-5">
				{vigenteActiva ?
					<EstadoDecisionAuditor vigente={vigente} intl={intl} />
					:
					<div className="text-truncate">
						<small className="text-muted">
							<FormattedMessage id="formularios.validacionGranular.sin_decision" defaultMessage="Sin decisión (conforme por defecto)" />
						</small>
					</div>
				}
			</div>
		</div>
	);
}

export default function ValidacionGranularSeccionReadOnly(props) {
	let intl = props.intl;
	let valoresDinamicos = props.valoresDinamicos || [];
	let itemsRelevantes = valoresDinamicos.filter(esItemRelevante);

	if (itemsRelevantes.length === 0) {
		return (
			<div className="text-muted">
				<FormattedMessage id="formularioAbm.validacion_checklist.sin_items" defaultMessage="No hay ítems de checklist para mostrar" />
			</div>
		);
	}

	return (
		<React.Fragment>
			<div className="row font-weight-bold border-bottom pb-1 mx-0">
				<div className="col-1"></div>
				<div className="col-3"><FormattedMessage id="formularios.validacionGranular.col_item" defaultMessage="Ítem" /></div>
				<div className="col-3"><FormattedMessage id="formularios.validacionGranular.col_operador" defaultMessage="Registrado por el operador" /></div>
				<div className="col-5"><FormattedMessage id="formularios.validacionGranular.col_supervisor" defaultMessage="Decisión del supervisor" /></div>
			</div>
			{itemsRelevantes.map((valorDinamico, index) => renderFila(valorDinamico, index, intl))}
		</React.Fragment>
	);
}
